import { Article, Category } from '@wix/answers-api';
import { Box } from '@wix/design-system';
import { FunctionComponent } from 'react';

import { LeftNavClickEventInfo } from '..';
import { WIXEL_CATEGORY_ID } from '../../../constants';
import { CategoryPageHeader } from '../CategoryPageHeader';
import css from '../index.module.scss';
import { StudioCategoryAddon } from '../StudioCategoryAddon';
import { SubcategoryCard } from '../SubcategoryCard/Index';
import { WixelCategoryBanner } from '../WixelCategoryBanner';

export const WIX_STUDIO_CATEGORY_ID = '8557ec0a-42e4-48b4-a964-7df1f14df2e0';

export type NonLeafCategoryPageProps = {
  selectedCategory: Category;
  subcategories: Category[];
  categoryArticlesMap: { [key: string]: Article[] };
  onClickSubcategory: (
    category: Category,
    event: LeftNavClickEventInfo
  ) => void;
  onClickArticle: (article: Article, event: LeftNavClickEventInfo) => void;
};

export const NonLeafCategoryPage: FunctionComponent<
  NonLeafCategoryPageProps
> = ({
  selectedCategory,
  subcategories,
  categoryArticlesMap,
  onClickSubcategory,
  onClickArticle,
}) => {
  const isWixStudioCategory = selectedCategory.id === WIX_STUDIO_CATEGORY_ID;

  return (
    <Box className={css.categoryDetailsWrapper} align="center">
      <Box direction="vertical">
        {selectedCategory.id === WIXEL_CATEGORY_ID ? (
          <WixelCategoryBanner category={selectedCategory} />
        ) : (
          <CategoryPageHeader selectedCategory={selectedCategory} />
        )}
        <div className={css.subcategories}>
          {subcategories.map((subcategory, idx) => (
            <Box
              key={subcategory.id}
              className={css.subcategory}
              direction="vertical"
            >
              <SubcategoryCard
                categoryOrder={idx + 1}
                onClickSubcategory={onClickSubcategory}
                onClickArticle={onClickArticle}
                category={subcategory}
                articles={categoryArticlesMap[subcategory.id]}
              />
            </Box>
          ))}
        </div>
        {isWixStudioCategory ? (
          <div className={css.StudioCategoryAddonWrapper}>
            <StudioCategoryAddon
              categoryId={selectedCategory.id}
              lastItemOrder={subcategories.length}
            />
          </div>
        ) : null}
      </Box>
    </Box>
  );
};
